export default {"src":"/_next/static/media/CFLT.cab5a152.svg","height":18,"width":18};